function filterShopifyEvent(event, domElement, callback) {
    let executeCallback = false;
    if (event.type.includes('shopify:section')) {
        if (domElement.hasAttribute('data-section-id') && domElement.getAttribute('data-section-id') === event.detail.sectionId) executeCallback = true
    } else if (event.type.includes('shopify:block') && event.target === domElement) { 
        executeCallback = true 
    }
    if (executeCallback) callback(event)
}

// is in viewport
function inViewport(elem, callback, options = {}) {
    return new IntersectionObserver(entries => {
        entries.forEach(entry => callback(entry))
    }, options).observe(document.querySelector(elem));
}

/* How to inViewport
document.addEventListener("DOMContentLoaded", () => {
    inViewport('[data-inviewport]', element => {
        if (!element.isIntersecting) { document.querySelector('#add2cart-cta').classList.add('active') } 
        else { document.querySelector('#add2cart-cta').classList.remove('active') }
    });
});
*/

// Toggle Body Class
let toggleBodyClass = function(arg) { 
    document.body.classList.toggle(arg);
}
// Get Element Height
function getElementHeight(targetElement,appendTo,cssVar) {
    let element = document.querySelector(targetElement);

    if (element) {
        let elementHeight = element.offsetHeight;
        document.querySelector(appendTo).style.setProperty(cssVar, `${elementHeight}px`);
    }
}

// first we get the viewport height and we multiple it by 1% to get a value for a vh unit
const getSetVh = () => { const roundedVh = Math.round(window.innerHeight * 0.01); document.body.style.setProperty('--vh', `${roundedVh}px`) };
window.addEventListener('resize', getSetVh);

// Browser check
function getBrowser() {
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) || Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0 || navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
    const isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime) || navigator.userAgent.indexOf('Chrome') != -1;
    const isFirefox = typeof InstallTrigger !== 'undefined' || navigator.userAgent.indexOf('Firefox') != -1;
    const isEdge = !!window.StyleMedia || navigator.userAgent.indexOf('Edge') != -1

    if (isSafari) document.documentElement.classList.add('safari');
    if (isChrome) document.documentElement.classList.add('chrome');
    if (isFirefox) document.documentElement.classList.add('firefox');
    if (isEdge) document.documentElement.classList.add('edge');
}

// Toggle
    let toggleClass = function(qSelectors, bodyClass) {   
        document.querySelectorAll(qSelectors).forEach(e => e.addEventListener('click', () => toggleBodyClass(bodyClass)))
    }
// Menu
    let toggleMenu = function() { 
        toggleClass('.fire-menu, .shrink-menu', 'open-menu')
    }
// Cart — event delegation so .cartc keeps working after rivets re-renders DOM
    let toggleCart = function() {
        document.addEventListener('click', (e) => {
            const trigger = e.target.closest && e.target.closest('.carto, .cartc');
            if (!trigger) return;
            document.body.classList.toggle('open-cart');
            document.body.classList.remove('hideheader');
        });

        document.addEventListener('keydown', (e) => {
            // ESC closes cart from anywhere
            if (e.key === 'Escape' && document.body.classList.contains('open-cart')) {
                document.body.classList.remove('open-cart');
                document.body.classList.remove('hideheader');
                return;
            }
            // Enter/Space when focused on cart trigger
            const trigger = e.target.closest && e.target.closest('.carto, .cartc');
            if (trigger && (e.key === 'Enter' || e.key === ' ')) {
                e.preventDefault();
                document.body.classList.toggle('open-cart');
                document.body.classList.remove('hideheader');
            }
        });
    }

    function initializeDetailsControls() {
        // Handle dropdown menu
        const detailsElementsLv1 = document.querySelectorAll('details.lv1');
        const detailsElementsClosex = [...document.querySelectorAll('details.closex')];
    
        function closeOtherDetails(element) {
            const detailsOpened = document.querySelectorAll('details[open].lv1');
            for (const item of detailsOpened) {
                if (element !== item) {
                    item.removeAttribute('open');
                }
            }
        }

        function closeAllDetailsExcept(target) {
            detailsElementsClosex.forEach(f => !f.contains(target) ? f.removeAttribute('open') : '');
            a11yDetails();
        }
    
        function closeAllDetails() {
            detailsElementsClosex.forEach(f => f.removeAttribute('open'));
            a11yDetails();
        }
    
        // Dropdown menu
        detailsElementsLv1.forEach(item => {
            item.addEventListener('click', function() {
                closeOtherDetails(this);
            });
        });
    
        // Close details when clicked outside
        document.addEventListener('click', function(e) {
            if (!detailsElementsClosex.some(f => f.contains(e.target))) {
                closeAllDetails();
            } else {
                closeAllDetailsExcept(e.target);
            }
        });
    
        // Close details with esc key
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' || e.keyCode === 27) {
                closeAllDetails();
            }
        });
    
        // Initial accessibility settings
        a11yDetails();
    }

    function a11yDetails() {
        document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
            summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));
            
            if(summary.nextElementSibling.getAttribute('id')) {
                summary.setAttribute('aria-controls', summary.nextElementSibling.id);
            }
            
            summary.addEventListener('click', (event) => {
                event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
            });
        });
    }
    

// update button price on variant change 
function updatePrice(obj,idd) {
    var uid = obj.options[obj.selectedIndex].getAttribute('data-price');
    var pb = document.querySelector('.uprice'+idd);
    pb.innerHTML = uid;
}

function selectOptions(obj,idd) { updatePrice(obj,idd) }

// Debug
if (window.location.href.indexOf("debug") > -1) {
    var OpenThinking = OpenThinking || {}; OpenThinking.theme = { "name":"Bullet", "version":`${window.BOOMR.themeVersion}` };
    console.log(`${OpenThinking.theme.name} v${OpenThinking.theme.version}`);
}

// AJAX cart.js
// AJAX cart init can be located in theme.liquid
function ajaxCart(obj) {
    // Show loading feedback
    obj.classList.add('loading');

    // on cart request success
    $(document).ajaxSuccess(function(event, jqxhr, settings) {
        if (settings.url == '/cart/add.js' || settings.url == '/cart/change.js') {
            // on cart request complete (just in case)
            $(document).on('cart.requestComplete', function(event, cart) {
                // Update # of items in cart
                document.getElementById('counter').setAttribute('data-count', cart.item_count);
                // Open cart
                document.body.classList.add('open-cart');
                document.body.classList.add('hideheader');
                // Remove loading feedback
                obj.classList.remove('loading');
            });
        }
    });

    // on cart request error
    $(document).ajaxError(function(event, jqxhr, settings) {
        if (settings.url == '/cart/add.js' || settings.url == '/cart/change.js') {
            obj.classList.remove('loading'); // Remove loading feedback

            const errorDescription = jqxhr.responseJSON.description;
            if (errorDescription) {
                // Since errorDescription is a string, no need to iterate
                alert(errorDescription);
                console.log(errorDescription);
            }
        }
    });

}

// Update # of items in cart — global jQuery listener (works for add/remove/update via CartJS)
// NOTE: CartJS fires cart.requestComplete as jQuery event with (event, cart) signature.
// Native document.addEventListener can't receive cart data from jQuery trigger, so we use jQuery here.
$(document).on('cart.requestComplete', function(event, cart) {
    if (!cart) return;
    var counter = document.getElementById('counter');
    if (counter) counter.setAttribute('data-count', cart.item_count);
    // Dispatch a native CustomEvent so vanilla JS listeners (promo bar) can react
    document.dispatchEvent(new CustomEvent('ks:cartUpdate', { detail: cart }));
});

// Bullet marquee
if (!customElements.get('bullet-marquee')) customElements.define('bullet-marquee', class bulletMarquee extends HTMLElement {
    constructor() { super(); if (window.ResizeObserver) new ResizeObserver(this.duration.bind(this)).observe(this); }

    duration(entries) {
        const scrollingSpeed = parseInt(this.getAttribute('bullet-speed') || 5);
        const contentWidth = entries[0].contentRect.width;
      
        // Calculate the slowFactor based on content width
        let slowFactor = contentWidth <= 375 ? 1 : contentWidth >= 1280 ? 3 : 1 + (contentWidth - 375) / (1280 - 375);

        // Calculate the scrolling speed with the adjusted slowFactor
        const scrollingDuration = (scrollingSpeed * slowFactor * entries[0].target.querySelector('span').clientWidth / contentWidth).toFixed(3);

        this.style.setProperty('--bullet-speed', `${scrollingDuration}s`);
    }
});

/*** init app */
function app() {
    getSetVh(); // get Viewport Height
    getBrowser(); // get the browser
    toggleMenu(); // toggle Menu
    toggleCart(); // toggle Cart
    initializeDetailsControls(); // call details 
}

/*** on DOM ready **/
document.addEventListener("DOMContentLoaded", () => { app() })

// PLP mobile: on fresh load, scroll past breadcrumbs so user lands on logo+filters
window.addEventListener('load', function() {
    if (!/^\/collections\//.test(location.pathname)) return;
    if (window.innerWidth >= 778) return;     // mobile only
    if (window.scrollY > 0) return;            // skip on back-navigation (browser restored scroll)
    var bc = document.querySelector('main .breadcrumb');
    if (!bc) return;
    var rect = bc.getBoundingClientRect();
    var targetY = rect.bottom + window.scrollY;
    if (targetY > 0 && targetY < 200) window.scrollTo(0, targetY);
});

// #10 — PLP mobile auto-cycling carousel.
// Behaviour: when user stops scrolling for 2s, visible product cards start
// cycling their images with a stagger (so they're not synchronised). User
// swipe takes over per-card; 3s after release the card returns to slide 1.
(function() {
    // Run on every touch device (phones AND tablets like iPad). Only a real
    // desktop-with-a-mouse opts out — there the theme's hover swap applies.
    var isMouseDesktop = window.matchMedia('(min-width: 778px)').matches
                      && window.matchMedia('(hover: hover)').matches;
    if (isMouseDesktop) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var STAGGER_MS = 350;       // delay between cards starting cycle
    var CYCLE_MS   = 2800;      // ms between slides on auto-cycle
    var IDLE_MS    = 2000;      // page-scroll idle before starting cycles
    var RESET_MS   = 3000;      // ms after user releases before returning to slide 1
    var SCROLL_ANIM_MS = 500;   // ignore scroll events for this long after auto-scroll

    var state = new WeakMap();      // track → { autoTimer, resetTimer, isUserActive, isAutoScrolling, idx }
    var visible = new Set();        // currently visible tracks (in viewport)
    var pageScrollIdle = null;
    var isPageScrolling = false;

    // Image prefetch queue — actually DOWNLOADS every slide into cache (via a
    // detached Image), so swipe/auto-cycle never lands on an un-fetched slide.
    // Reliable on Safari too, where flipping loading="lazy"→"eager" alone does
    // not force a fetch. Concurrency-capped + priority so near cards go first.
    var PF_MAX = 6;                 // parallel downloads
    var pfActive = 0;
    var pfQueue = [];               // [{img, prio}]
    var pfSeen = new WeakSet();     // imgs already queued

    function init() {
        var tracks = document.querySelectorAll('.card-img-track');
        if (!tracks.length) return;

        var io = new IntersectionObserver(function(entries) {
            entries.forEach(function(e) {
                if (e.isIntersecting) {
                    visible.add(e.target);
                } else {
                    visible.delete(e.target);
                    stopCycle(e.target);
                }
            });
        }, { threshold: 0.4 });

        // FIX (blank-slide bug): download a card's slides into cache well before
        // it reaches the viewport (~1.5 screens ahead), at high priority. Slides
        // 2-4 sit off-screen horizontally so native lazy never fetched them.
        var preloadIo = new IntersectionObserver(function(entries) {
            entries.forEach(function(e) {
                if (e.isIntersecting) { preloadCard(e.target, 0); preloadIo.unobserve(e.target); }
            });
        }, { rootMargin: '1000px 0px', threshold: 0 });

        tracks.forEach(function(track) {
            // Only init carousels with >1 slide
            if (track.querySelectorAll('.card-img-slide').length <= 1) return;

            state.set(track, { autoTimer: null, resetTimer: null, isUserActive: false, isAutoScrolling: false, idx: 0 });
            io.observe(track);
            preloadIo.observe(track);

            track.addEventListener('touchstart', function() {
                var s = state.get(track);
                s.isUserActive = true;
                clearTimeout(s.autoTimer);
                clearTimeout(s.resetTimer);
            }, { passive: true });

            track.addEventListener('touchend', function() {
                var s = state.get(track);
                s.isUserActive = false;
                clearTimeout(s.resetTimer);
                s.resetTimer = setTimeout(function() {
                    if (s.isUserActive) return;
                    resetToFirst(track);
                    setTimeout(function() { if (!isPageScrolling && !s.isUserActive) startCycle(track); }, SCROLL_ANIM_MS);
                }, RESET_MS);
            }, { passive: true });

            track.addEventListener('scroll', function() {
                var s = state.get(track);
                if (s.isAutoScrolling) return;
                // sync idx from user-driven scroll
                var w = track.offsetWidth;
                if (w > 0) s.idx = Math.round(track.scrollLeft / w);
            }, { passive: true });
        });

        // Page scroll: pause all cycles, restart after IDLE_MS of stillness
        window.addEventListener('scroll', function() {
            isPageScrolling = true;
            tracks.forEach(function(t) { var s = state.get(t); if (s) clearTimeout(s.autoTimer); });
            clearTimeout(pageScrollIdle);
            pageScrollIdle = setTimeout(function() {
                isPageScrolling = false;
                startVisibleCarousels();
            }, IDLE_MS);
        }, { passive: true });

        // Initial start (after one IDLE_MS so user gets a chance to interact first)
        setTimeout(function() {
            if (isPageScrolling) return;
            startVisibleCarousels();
        }, IDLE_MS);

    }

    function startVisibleCarousels() {
        var i = 0;
        visible.forEach(function(track) {
            var s = state.get(track);
            if (!s || s.isUserActive) return;
            setTimeout(function() {
                if (!isPageScrolling && !s.isUserActive) startCycle(track);
            }, i * STAGGER_MS);
            i++;
        });
    }

    function startCycle(track) {
        var s = state.get(track);
        if (!s || s.isUserActive || isPageScrolling) return;
        var slides = track.querySelectorAll('.card-img-slide');
        if (slides.length <= 1) return;

        clearTimeout(s.autoTimer);
        s.autoTimer = setTimeout(function tick() {
            if (s.isUserActive || isPageScrolling || !visible.has(track)) return;
            s.idx = (s.idx + 1) % slides.length;
            scrollToSlide(track, s.idx);
            s.autoTimer = setTimeout(tick, CYCLE_MS);
        }, CYCLE_MS);
    }

    function stopCycle(track) {
        var s = state.get(track);
        if (s) clearTimeout(s.autoTimer);
    }

    // Queue every slide image of a card for download into cache. prio 0 = near
    // viewport (front of queue), prio 1 = rest of page (back). First slide of
    // each card is enqueued before the others so covers load first, then 2-4.
    function preloadCard(track, prio) {
        var imgs = [].slice.call(track.querySelectorAll('.card-img-slide img'));
        imgs.forEach(function(img) {
            // flip to eager so, once cached, it paints instantly on swipe/cycle
            if (img.getAttribute('loading') === 'lazy') img.setAttribute('loading', 'eager');
            enqueuePrefetch(img, prio);
        });
    }

    function enqueuePrefetch(img, prio) {
        if (!img || pfSeen.has(img)) return;
        pfSeen.add(img);
        if (prio === 0) pfQueue.unshift({ img: img }); else pfQueue.push({ img: img });
        pumpPrefetch();
    }

    function pumpPrefetch() {
        while (pfActive < PF_MAX && pfQueue.length) {
            var img = pfQueue.shift().img;
            pfActive++;
            var pre = new Image();
            if (img.sizes) pre.sizes = img.sizes;
            var ss = img.getAttribute('srcset');
            if (ss) pre.srcset = ss;
            var done = function() { pfActive--; pumpPrefetch(); };
            pre.onload = done;
            pre.onerror = done;
            pre.src = img.currentSrc || img.src;   // triggers the actual download
        }
    }

    function resetToFirst(track) {
        var s = state.get(track);
        if (!s || s.idx === 0) return;
        s.idx = 0;
        scrollToSlide(track, 0);
    }

    function scrollToSlide(track, idx) {
        var s = state.get(track);
        s.isAutoScrolling = true;
        track.scrollTo({ left: idx * track.offsetWidth, behavior: 'smooth' });
        clearTimeout(s._animEnd);
        s._animEnd = setTimeout(function() { s.isAutoScrolling = false; }, SCROLL_ANIM_MS);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();